<div [auxTooltip]="tooltip" [ngClass]="className">
  {{ name | hideLastName }}
</div>
